import {IModelBase, ModelBase} from "./model-base";
import {EmploymentStatus} from "./employment-status";
import {EmployeeEventResponseDto} from "../../../models/event/employee-event-response-dto";
import {UserInformation} from "../../../x-models/user-information";
import {EmployeeStatsDto} from "./employee-stats-dto";
import {EmployeeAttributeNl} from "./employee-attribute-nl";

export class EmployeeNl extends ModelBase implements IModelBase {
  firstName: string = "";
  lastName: string = "";
  /** First employment begin, computed from the periods (undefined when no period exists). */
  joined?: Date;
  /** End of employment — null/undefined while a stint is open (currently employed). */
  left?: Date;
  /** Whether the employee is currently employed (an open employment period covers now). */
  isEmployed: boolean = true;
  /**
   * Employed, upcoming or former right now (#864), computed server-side over every period. Read it through
   * `employmentStatusOf`, which also covers a server that predates the field.
   */
  employmentStatus?: EmploymentStatus;
  /** When {@link employmentStatus} is `upcoming`: the instant the next period starts. */
  employmentStartsAt?: Date;
  /**
   * Whether the employee is employed on the date this roster was requested for (#403); equal to
   * {@link isEmployed} when the request named no date.
   *
   * Computed server-side over the employment stints. It exists because {@link joined}/{@link left} are an
   * *outer envelope* — `left` is undefined while any stint is open — so a client-side
   * `joined <= at && (!left || left > at)` test reports someone employed Jan–Mar and re-hired in July as
   * employed in May as well.
   */
  isEmployedOnQueryDate: boolean = true;

  canLogin: boolean = false;

  /**
   * Absent (null) on the lean roster — see {@link employeeStats}.
   */
  telegram: UserInformation | undefined;

  // shift maker
  responses: EmployeeEventResponseDto[] = [];

  /**
   * The worktime statistics — present only on the roster fetched WITH statistics.
   *
   * `EmployeeHttpService.listNl(start, all, stats)` answers two shapes (#457): with `stats = false` the server
   * sends `employeeStats: null`, `telegram: null` and `employeeAttributes: []`, because computing the statistics
   * costs it every shift response of every employee in the roster plus a per-shard event/location resolution.
   * The field stays non-optional here so the shift maker — the only consumer that reads it, and one that always
   * asks with statistics — keeps its ergonomics; a NEW consumer of this field must therefore check which shape
   * it asked for rather than assume the object is there.
   */
  employeeStats: EmployeeStatsDto = new EmployeeStatsDto()

  /**
   * Empty on the lean roster — see {@link employeeStats}.
   */
  employeeAttributes: EmployeeAttributeNl[] = [];
}
